import { Stack, Typography, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { theme } from '../../../../theme/ThemeProvider';
import { StatusDot } from '../StatusDot/StatusDot';

/**
 * Shown whenever the station socket is not OPEN after the first load.
 *
 * Without it a dropped socket looks identical to a station that simply has
 * nothing to report, and the driver reads a stale connector status as
 * "unavailable". Tinted with the palette's warning colour rather than neutral
 * white-on-white, so the strip encodes the state instead of just carrying text.
 */
export const ConnectionBanner = () => {
  const { t } = useTranslation();
  const accent = theme.palette.orange.main;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      role="status"
      sx={{
        width: '100%',
        gap: '8px',
        padding: '8px 14px',
        borderRadius: '15px',
        backgroundColor: alpha(accent, 0.12),
        border: `1px solid ${alpha(accent, 0.3)}`,
      }}
    >
      <StatusDot color={accent} />
      <Typography variant="body2" sx={{ fontSize: '13px', color: accent }}>
        {t('orderPage.connection.reconnecting')}
      </Typography>
    </Stack>
  );
};
